import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { withCookies } from 'react-cookie';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { ReCaptcha } from 'react-recaptcha-v3';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import store from '../../store/index';
import { setData } from '../../actions/index';
import {
  saveUserToStore,
  setSessionCredentials,
  googleRecaptcha,
} from '../../helpers';

const styles = () => ({
  button: {
    marginTop: 40,
    padding: '16px 32px',
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  textField: {
    margin: '8px 0',
  },
});

class ParentLoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      remember: true,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onInputCheckboxChange = this.onInputCheckboxChange.bind(this);
    this.onLoginClick = this.onLoginClick.bind(this);
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onInputCheckboxChange(event) {
    this.setState({
      [event.target.name]: !this.state[event.target.name],
    });
  }

  onLoginClick(event) {
    const {
      cookies,
      enqueueSnackbar,
    } = this.props;

    googleRecaptcha('parent_login', (token) => {
    const params = {
      email: this.state.email,
      password: this.state.password,
      'recaptcha-token': token,
    };

    if (this.state.remember) {
      params.remember = true;
    }

    axios
      .post(`${window.apiUrl}/login`, qs.stringify(params))
      .then((response) => {
        const { data } = response;
        if (data.success) {
          saveUserToStore(data.data);
            if (
                response.data.meta
                && response.data.meta.session_id
            ) {
                setSessionCredentials(cookies, response.data.meta.session_id, this.state.remember);
            }
        } else {
          enqueueSnackbar(data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });

          this.setState({
            password: '',
          })
        }
      })
      .catch((thrown) => {});
    });
  }

  render() {
    const {
      email,
      password,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className="parent-login-page">
        <TextField
          label={t('Email address')}
          placeholder={t('Your email address')}
          fullWidth
          margin="normal"
          type="email"
          name="email"
          InputLabelProps={{
            shrink: true,
          }}
          value={email}
          onChange={this.onInputChange}
          className={classes.textField}
          required
          autoComplete="off"
        />
        <TextField
          label={t('Your password')}
          placeholder={t('Your password')}
          fullWidth
          margin="normal"
          type="password"
          name="password"
          InputLabelProps={{
            shrink: true,
          }}
          value={password}
          onChange={this.onInputChange}
          className={classes.textField}
          required
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={this.state.remember}
              onChange={this.onInputCheckboxChange}
              value="true"
              name="remember"
            />
)}
          margin="normal"
          label={t('Remember me')}
        />
        <Typography>
          {t('Forgot your password?')}
          <span>&nbsp;</span>
          <a href="https://www.classcharts.com/parent/forgot" target="_blank" rel="noopener">{t('Click here to reset.')}</a>
        </Typography>
        <ReCaptcha
          sitekey={googleRecaptchaSiteKey}
          action="parent_login"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={this.onLoginClick}
          className={`login-button ${classes.button}`}
        >
          {t('Log In')}
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(withCookies(withSnackbar(withTranslation()(ParentLoginPage))));
